import appApi from '../../../../api/app-api';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import { UpdateSecurityGroupRequest } from '../../../../api/types/settings/permissions/security-group-entity';

export const updateSecurityGroupOperation = async (
  groupId: number,
  payload: UpdateSecurityGroupRequest,
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
) => {
  const name = payload.name.trim();

  if (!name) {
    toast.warn('יש להזין שם קבוצה');
    return;
  }
  if (name.length > 128) {
    toast.warn('שם הקבוצה יכול להכיל עד 128 תווים');
    return;
  }

  try {
    setLoading(true);
    const res = await appApi.updateSecurityGroup(groupId, { name });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }

    toast.success('קבוצת ההרשאות עודכנה בהצלחה');
    onSuccess();
  } catch (error) {
    console.error('updateSecurityGroupOperation failed:', error);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  } finally {
    setLoading(false);
  }
};
